import { css } from 'linaria';
import { HighlightIcon } from '@pocket/web-ui';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const highlightWrapper = "h189afap";
export function HighlightsTag({
  count,
  margin
}) {
  const className = classNames(highlightWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <HighlightIcon />
      <span>{count}</span>
    </div>;
}

require("../../../.linaria-cache/src/components/tags/tag-highlights.linaria.module.css");